<template>
  <div id="changePassword">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="4" md="4" class="change-password_slim">
          <v-card elevation="10" class="change_password_card">
            <v-card-text class="change-password">
              <v-alert v-if="!!messageOk" type="success">
                {{ messageOk }}</v-alert
              >
              <v-alert v-if="!!message" type="error"> {{ message }}</v-alert>
              <v-form
                ref="cpform"
                id="change-password-form"
                @submit.prevent="submitchange - password"
                autocomplete="off"
              >
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="8" md="8">
                    <h1 class="change-password_prihlasenie">Zmeniť heslo</h1>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center" no-gutters>
                  <v-col cols="12" sm="8" md="8">
                    <form-component title="">
                      <v-text-field
                        v-model="password_old"
                        :append-icon="showPass_old ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.password_old]"
                        :type="showPass_old ? 'text' : 'password'"
                        :label="'Pôvodné heslo'"
                        class="dynamic-input-control"
                        outlined
                        @click:append="showPass_old = !showPass_old"
                      ></v-text-field>
                    </form-component>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center" no-gutters>
                  <v-col cols="12" sm="8" md="8">
                    <form-component title="">
                      <v-text-field
                        v-model="password_new1"
                        :append-icon="showPass_new1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.password_new1]"
                        :type="showPass_new1 ? 'text' : 'password'"
                        :label="'Nové heslo'"
                        class="dynamic-input-control"
                        outlined
                        @click:append="showPass_new1 = !showPass_new1"
                      ></v-text-field>
                    </form-component>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center" no-gutters>
                  <v-col cols="12" sm="8" md="8">
                    <form-component title="">
                      <v-text-field
                        v-model="password_new2"
                        :append-icon="showPass_new2 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.password_new2]"
                        :type="showPass_new2 ? 'text' : 'password'"
                        :label="'Zopakujte heslo'"
                        class="dynamic-input-control"
                        outlined
                        @click:append="showPass_new2 = !showPass_new2"
                      ></v-text-field>
                    </form-component>
                  </v-col>
                </v-row>
              </v-form>
              <v-row align="center" justify="center" class="">
                <v-col cols="12" sm="8" md="8">
                  <v-btn color="primary" depressed @click="changePassword"
                    >Zmeniť heslo</v-btn
                  >
                  <v-btn
                    to="/"
                    color="secondary"
                    :ripple="false"
                    plain
                    class="change-password-cancel"
                    @click="changePasswordCancel"
                    >Zrušiť</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import FormComponent from '../components/FormComponent.vue';
import protectedAxios from '../auth/axios.js';
import TextBox from '../components/basic/TextBox.vue';

export default {
  components: {
    FormComponent,
    TextBox,
  },
  data() {
    return {
      showPass_old: false,
      showPass_new1: false,
      showPass_new2: false,
      password_old: '',
      password_new1: '',
      password_new2: '',
      message: '',
      messageOk: '',
      rules: {
        password_old: value => !!value || 'Zadajte pôvodné heslo!',
        password_new1: value => !!value || 'Zadajte nové heslo!',
        password_new2: value => !!value || 'Zopakujte nové heslo!',
      },
    };
  },
  methods: {
    changePassword() {
      protectedAxios
        .post('/login/changepassword', {
          OldPass: this.password_old,
          NewPass1: this.password_new1,
          NewPass2: this.password_new2,
        })
        .then(res => {
          if (res.data.status != 0) {
            this.message = res.data.message;
            this.messageOk = '';
          } else {
            //this.lostPassword = !this.lostPassword;
            this.message = '';
            this.messageOk = res.data.message;
            this.password_old = '';
            this.password_new1 = '';
            this.password_new2 = '';
            this.showPass_old = false;
            this.showPass_new1 = false;
            this.showPass_new2 = false;
            this.$refs.cpform.resetValidation();
          }
        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {});
    },
    changePasswordCancel() {
      //console.log('changePasswordCancel');
    },
  },
};
</script>
<style lang="sass"></style>
